import {
    ChatAlt2Icon,
    CogIcon,
    DotsVerticalIcon,
    HeroXMarkIcon,
    NinchatSidebarIcon,
    UserAddIcon,
} from '../../Icon'
import {
    Dropdown,
    DropdownButtonNew as DropdownButton,
    DropdownContent,
} from '../../Dropdown'
import {
    styledActionContainer,
    styledActions,
    styledMembers,
} from '../styles/Menubar'
import Button from '../../Button'
import ChannelMembers from '../../ChannelMembers'
import {ChannelMenubarViewProps} from './types'
import {Icon} from '../../Icon/types'
import LeaveChannelPromiseModal from 'components/Modal/LeaveChannelPromiseModal'
import MenubarName from '../MenubarName'
import React from 'react'
import {styled} from '../../../stitches/config'
import {styledItem} from 'components/Dropdown/styles'
import {useChannelDetails} from 'hooks/ninchat'
import {usePromiseModal} from 'components/Modal/PromiseModal/hooks/usePromiseModal'
import {useTranslation} from 'react-i18next'

const StyledActionContainer = styled('div', styledActionContainer)
const StyledActions = styled('div', styledActions)
const StyledMembers = styled('div', styledMembers)
const StyledItem = styled('div', styledItem)

const ChannelMenubarView = (props: ChannelMenubarViewProps): React.ReactElement => {
    const {t} = useTranslation()
    const {
        hasChannelPermission,
        chat,
        hasUnreadMessages,
        isActiveVideoChannel,
        isChannelSidebarOpen,
        onChannelInvite,
        onChannelSettings,
        onToggleChannelSidebar,
        onToggleChat,
    } = props

    const channelId = chat.channel_id
    const channelDetails = useChannelDetails({channelId})
    const openLeaveChannelModal = usePromiseModal(LeaveChannelPromiseModal, {instanceId: 'leaveChannel'})

    const leaveChannel = (): void => {
        openLeaveChannelModal({
            channelId,
            channelName: channelDetails.name,
        }).then(
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            () => {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            () => {},
        )
    }

    return (
        <>
            <MenubarName
                chat={chat}
                isChannelSidebarOpen={isChannelSidebarOpen}
                onToggleChannelSidebar={onToggleChannelSidebar}
            />
            <StyledActionContainer>
                <StyledMembers>
                    {!isChannelSidebarOpen &&
                    <ChannelMembers
                        arrangeInRow={false}
                        channel_id={channelId as string}
                        openSidebar={onToggleChannelSidebar}
                    />}
                </StyledMembers>
                <StyledActions>
                    <Dropdown>
                        <DropdownButton caret={false} color='text' iconRight={DotsVerticalIcon} />
                        <DropdownContent direction='fixed-end'>
                            <StyledItem>
                                <Button
                                    color='text'
                                    iconLeft={NinchatSidebarIcon}
                                    onPress={() => { onToggleChannelSidebar() }}
                                    text={t('Show channel info')}
                                    title={t('Show channel info')}
                                />
                            </StyledItem>
                            {!!hasChannelPermission &&
                            <>
                                <StyledItem>
                                    <Button
                                        color='text'
                                        iconLeft={UserAddIcon}
                                        onPress={() => { onChannelInvite() }}
                                        text={t('Invite people to channel')}
                                        title={t('Invite people to channel')}
                                    />
                                </StyledItem>
                                <StyledItem>
                                    <Button
                                        color='text'
                                        iconLeft={CogIcon}
                                        onPress={() => onChannelSettings()}
                                        text={t('Channel settings')}
                                        type='button'
                                    />
                                </StyledItem>
                            </>}
                            <StyledItem>
                                <Button
                                    color='text'
                                    iconLeft={HeroXMarkIcon as unknown as Icon}
                                    onPress={() => leaveChannel()}
                                    text={t('Leave channel')}
                                    type='button'
                                />
                            </StyledItem>
                        </DropdownContent>
                    </Dropdown>
                    {!!isActiveVideoChannel &&
                        <Button
                            color={hasUnreadMessages ? 'highlight' : 'text'}
                            iconLeft={ChatAlt2Icon}
                            onPress={() => { onToggleChat() }}
                            title={t('Toggle chat')}
                        />}
                    {!isChannelSidebarOpen &&
                        <Button
                            color='text'
                            iconLeft={NinchatSidebarIcon}
                            onPress={() => { onToggleChannelSidebar() }}
                            title={t('Show channel info')}
                        />}
                </StyledActions>
            </StyledActionContainer>
        </>
    )
}

export default ChannelMenubarView
